module.exports = __webpack_public_path__ + "img/html.9a26050a.png";